import React from 'react';
import styles from '../styles.module.scss';

function CommentPanelHeader({ onClose }) {
  return (
    <div className={styles.header}>
      <h3 className={styles.title}>Comments</h3>
      <button
        className={styles.closeButton}
        aria-label="Close comments"
        onClick={onClose}
      >
        <img
          src="/icons/close-comments-icon.svg"
          alt="Close"
          width={20}
          height={20}
        />
      </button>
    </div>
  );
}
export default CommentPanelHeader;
